<template>
	<CRow>
		<CCol sm="12">
			<CButton @click="collapse=!collapse" color="primary" class="mb-2"
				v-show="$store.state.perms.view_all_users
					|| $store.state.perms.view_same_group_users">
				فیلتر داده‌ها
			</CButton>
			<CCollapse :show="collapse" :duration="400">
				<CCard>
					<CCardHeader>
						<strong>گزینه‌های فیلتر</strong>
					</CCardHeader>
					<CCardBody>
						<CRow>
							<CCol sm="3">
								<CInput v-model="form.first_name.val" :description="form.first_name.inv" label="نام" />
							</CCol>
							<CCol sm="3">
								<CInput v-model="form.last_name.val" :description="form.last_name.inv" label="نام خانوادگی" />
							</CCol>
							<CCol sm="3">
								<CInput v-model="form.mobile.val" :description="form.mobile.inv" label="موبایل" dir="ltr" />
							</CCol>
							<CCol sm="3">
								<CInput v-model="form.email.val" :description="form.email.inv" label="ایمیل" dir="ltr" />
							</CCol>
						</CRow>
						<CRow>
							<CCol sm="3">
								<label>شهر</label>
								<model-select :options="cities" v-model="form.city_id.val" :description="form.city_id.inv" placeholder="انتخاب کنید">
								</model-select>
							</CCol>
							<CCol sm="3">
								<CSelect v-model="form.is_active.val" :description="form.is_active.inv" label="وضعیت"
								:options="[
									{value: '', label: 'هیچ‌کدام'},
									{value: 'true', label:'فعال'},
									{value: 'false', label:'غیرفعال'}
			                    ]"
								placeholder="انتخاب کنید" @change="form.is_active.val=$event.target.value" />
							</CCol>
							<CCol sm="3">
								<CInput v-model="form.national_code.val" :description="form.national_code.inv" dir="ltr" label="کد ملی" />
							</CCol>
							<CCol sm="3">
								<CInput v-model="form.postcode.val" :description="form.postcode.inv" dir="ltr" label="کد پستی" />
							</CCol>
						</CRow>
						<CRow>
							<CCol sm="3">
								<label>تاریخ</label>
								<date-picker placeholder="انتخاب کنید" v-model="form.created_at.val" :description="form.created_at.inv"></date-picker>
							</CCol>
							<CCol sm="3">
								<label>آخرین ورود</label>
								<date-picker placeholder="انتخاب کنید" v-model="form.last_login.val" :description="form.last_login.inv"></date-picker>
							</CCol>
							<CCol sm="3">
								<CSelect v-model="form.is_hoghoghi.val" :description="form.is_hoghoghi.inv" label="کاربر حقوقی" :options="[{value: 'true', label:'بله'}, {value: 'false', label: 'خیر'}]" placeholder="انتخاب کنید" @change="form.is_hoghoghi.val=$event.target.value" />
							</CCol>
							<CCol sm="3">
								<CSelect v-model="form.access_web_service.val" :description="form.access_web_service.inv" label="دسترسی به وب‌سرویس" :options="[{value: 'true', label:'فعال'}, {value: 'false', label: 'غیرفعال'}]" placeholder="انتخاب کنید" @change="form.access_web_service.val=$event.target.value" />
							</CCol>
						</CRow>
						<CRow>
							<CCol sm="3">
								<CSelect v-model="form.is_verified.val" :description="form.is_verified.inv" label="تایید کاربر" :options="[{value: 'true', label:'فعال'}, {value: 'false', label: 'غیرفعال'}]" placeholder="انتخاب کنید" @change="form.is_verified.val=$event.target.value" />
							</CCol>
						</CRow>
						<br>
						<div class="form-group form-actions">
							<CButton @click="validator();filter=true;page=1;get()" class="ml" color="primary">فیلتر</CButton>
							<CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
						</div>
					</CCardBody>
				</CCard>
			</CCollapse>
		</CCol>
		<CCol col="12" xl="12">
			<CCard>
				<CCardHeader>
					<strong>کاربرها</strong> 
					<div class="card-header-actions">
						تعداد: {{row_count}}
					</div>
				</CCardHeader>
				<CCardBody>
					<CCol sm="5">
						<CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
						{value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count"
						placeholder="تعداد سطرها" @change="limit=$event.target.value" />
					</CCol>
					<CDataTable hover striped :items="items" :fields="fields"
						:noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
						<template #full_name="data">
							<td>
								<router-link :to="`/profile/${data.item.id}`">
									{{data.item.full_name}}
								</router-link>
							</td>
						</template>
						<template #action="data">
							<td>
								<template>
									<div class="flex-container">
										<div @click="redirect_to(`/profile/${data.item.id}`)"
											v-c-tooltip.hover="'پروفایل'">
											<CIcon name="cilUserPlus" size="lg"/>
										</div>
										<div @click="redirect_to(`/user/${data.item.id}/password/reset`)"
											v-show="data.item.can_update"
											v-c-tooltip.hover="'تغییر رمز عبور'">
											<CIcon name="cilLockLocked" size="lg"/>
										</div>
										<div @click="redirect_to(`/user/${data.item.id}/edit`)"
											v-show="data.item.can_update"
											v-c-tooltip.hover="'ویرایش'">
											<CIcon name="cilPencil" size="lg"/>
										</div>
										<div @click="delete_modal=true;id=data.item.id"
											v-show="data.item.can_delete"
											v-c-tooltip.hover="'حذف'">
											<CIcon name="cilTrash" size="lg"/>
										</div>
									</div>
								</template>
							</td>
						</template>
          		</CDataTable>
				<br>
				<div> 
					<CPagination
					:activePage.sync="page"
					:pages="page_count"
					align="center"
					:doubleArrows="true"
					/>
				</div>
			</CCardBody>
		</CCard>
		</CCol>
		<CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
  </CRow>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
	components: { ModelSelect },
	data() {
		return {
			row_count: '',
			items: [],
			fields: [
				{ key: 'id', label: 'شناسه' },
				{ key: 'full_name', label: 'کاربر' },
				{ key: 'national_code', label: 'کدملی' },
				{ key: 'username', label: 'موبایل' },
				{ key: 'account_balance', label: 'موجودی (ریال)' },
				{ key: 'last_login', label: 'آخرین ورود' },
				{ key: 'action', label: '' },
			],
			collapse: false,
			form: {
				first_name: {val: '', inv: '', v: {max: 64}},
				last_name: {val: '', inv: '', v: {max: 64}},
				mobile: {val: '', inv: '', v: {max: 16}},
				email: {val: '', inv: '', v: {max: 64}},
				city_id: {val: '', inv: '', v: {max: 8}},
				is_active: {val: '', inv: '', v: {max: 8}},
				national_code: {val: '', inv: '', v: {max: 16}},
				postcode: {val: '', inv: '', v: {max: 16}},
				created_at: {val: '', inv: '', v: {max: 16}},
				last_login: {val: '', inv: '', v: {max: 16}},
				is_verified: {val: '', inv: '', v: {max: 8}},
				access_web_service: {val: '', inv: '', v: {max: 8}},
				is_hoghoghi: {val: '', inv: '', v: {max: 8}},
			},
			disable: false,
			filter: false,
			page: 1,
			page_count: 0,
			offset: 0,
			limit: 10,
			delete_modal: false,
			id: 0,
			cities: [],
		}
	},
	watch: {
		page: {
			handler() {
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		},
		limit: {
			handler() {
				this.page = 1;
                this.get();
			}
		}
	},
	mounted() {
		this.get();
		this.get_cities();
	},
	methods: {
		get_cities(){
			this.axios.get('cities/')
			.then(res => {
				res.data.map((value) => {
					this.cities.push({value: value.id, text: value.name});
				});
			})
		},
		get() {
			if(this.disable == false){
				let filter = '';
				if(this.filter){
					for (const key in this.form) {
						if(this.form[key].val != ''){
							if(key == 'created_at' || key == 'last_login'){
								filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
							} else {
								filter += `&${key}=` + this.form[key].val;
							}
						}
					}
				}
				this.axios.get('users/'
					+ '?count=1'
					+ filter)
					.then(res => {
						this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
						this.offset = 0;
						if(this.page != 1){
							this.offset = (this.page * this.limit) - this.limit;
						}
					})
				.finally(() => {
					this.axios.get('users/'
						+ '?limit=' + this.limit
						+ '&offset=' + this.offset
						+ filter)
						.then(res => {
							res.data.map(val => {
								val.full_name = `${val.first_name} ${val.last_name}`;
								val.account_balance = val.account_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								if (val.is_active == true) {
									val.is_active = 'فعال';
								} else {
									val.is_active = 'غیرفعال';
								}
								if (val.last_login == '0001-01-01T00:00:00Z') {
									val.last_login = '---';
								} else {
									val.last_login = this.$moment(val.last_login, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
								}
							});
							this.items = res.data;
						})
				})
			}
		},
		delete_row() {
			this.axios.delete('users/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
				});
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
				});
				this.delete_modal = false;
			})
		},
		remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get();
        },
		redirect_to(route) {
			this.$router.push(route);
		}
	},
	beforeCreate(){
		if(this.$store.state.perms.can_view_user_info_page == false
			&& this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>